module.exports = __webpack_public_path__ + "static/img/title-banner1-type3.6083b07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/3/title-banner1-type3.png
// module id = L+f6
// module chunks = 1